/*
 * @FileName: Do not edit
 * @Date: 2022-02-11 10:07:54
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-12 18:12:04
 * @FilePath: \mobile-portal\src\main.js
 */
import Vue from 'vue';
import 'babel-polyfill';
import FastClick from 'fastclick';
// 引入 vant

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';
// 引入图标库
import '../src/assets/iconfont/iconfont.css';
import '../src/assets/iconfont/iconfont.js';
// 引入特殊字体
import '../src/assets/font/font.css';
import App from './App';
import router from './router/router';
import i18n from './global/i18n';
import store from './store';

// 引入全局样式
import '../src/styles/index.scss';

import './mobile-touch.js';
import { Toast } from 'vant';


import Es6Promise from 'es6-promise';
import infiniteScroll from 'vue-infinite-scroll';
import $axios from 'axios';

// 移动端调试窗口
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole()
// Vue.use(vConsole);

Es6Promise.polyfill();

Toast.setDefaultOptions('loading', {
  message: '加载中...',
  forbidClick: true,
  duration: 0,
  loadingType: 'spinner',
});

Vue.use(infiniteScroll);
Vue.use(Toast);
Vue.use(ElementUI);


FastClick.attach(document.body);
Vue.config.productionTip = false;


(function () {
  $axios.get('serverConfig.json').then((result) => {
    // 设置成Vue的全局属性
    if (result.data) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in result.data) {
        // eslint-disable-next-line no-prototype-builtins
        if (result.data.hasOwnProperty(key)) {
          window[key] = result.data[key];
        }
      }
    }
    /* eslint-disable no-new */
    new Vue({
      i18n,
      router,
      store,
      render: h => h(App),
    }).$mount('#app-box');
  }).catch((error) => {
    /* eslint-disable no-new */
    new Vue({
      i18n,
      router,
      store,
      render: h => h(App),
    }).$mount('#app-box');
    throw error;
  });
}());
